export enum experimentKeyEnum {
  WIX_WEBSITES_PDP = 'vxw_pdp_hero_layout',
  WIX_WEBSITES_PDP_PERFORMANCE_ANALYSIS = 'vxw_websitespdp_performance_analysis',
  WIX_WEBSITES_PDP_HERO_PERSONALIZATION = 'vxw_websites_pdp_hero_personalization',
  WIX_WEBSITES_DOMAIN_SUGGESTIONS_PP = 'vxw_domain_suggestions_pp',
}

export enum variationKeyEnum {
  WIX_WEBSITES_PDP_CONTROL_VARIATION = 'control',
  WIX_WEBSITES_PDP_TEST_VARIATION = 'test',
  WIX_WEBSITES_DOMAIN_SUGGESTIONS_DEFAULT = 'default_pp',
  WIX_WEBSITES_DOMAIN_SUGGESTIONS_WITH_SEARCH = 'package_picker_with_domain_search_option',
}

export enum featureFlagKeyEnum {
  WIX_WEBSITES_DOMAIN_SUGGESTIONS_PP = 'vxw_domains_suggestions_pp',
  DIGITAL_VXW_FAQS = 'digital_vxw_faqs',
}

export const experimentLocales = ['en-gb', 'en-ca', 'fr-ca', 'en-nz', 'en-au']
export const dynamicHeroExperimentLocales = ['en-us', 'en-ie', 'en-ca', 'en-au', 'en-nz', 'en-sg', 'en-gb']
